/**
 * useActivitiesData — l'appel de l'onglet « Activités » du parent.
 *
 * Un seul appel, celui du legacy : `getStudent` sur l'enfant connecté
 * (`ParentActivitiesScreen.js:19-21`). En mode parent le jeton EST celui de l'enfant, donc l'id
 * est `currentUser.id`, comme le legacy le lit (`ParentActivitiesScreen.js:14`).
 *
 * Rien à consommer ici : c'est le réducteur `currentUser` qui range la réponse
 * (`currentUser.js:955`), le view-model ne lit la tranche que pour savoir si ça tourne.
 */
import { useCallback, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import { apiRequest } from "../../../../../../data/redux/actions/api"
import { studentsService } from "../../../../../../data/services/studentsService"
import { selectDisplayedStudent } from "../../../../view-models/shared/displayedStudent"

export function useActivitiesData() {
    const dispatch = useDispatch()
    const studentId = useSelector(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (state: any) => selectDisplayedStudent(state)?.id as string | number | undefined
    )

    const fetchStudent = useCallback(() => {
        if (studentId == null) return
        dispatch(apiRequest(studentsService.getStudent, { id: studentId }) as never)
    }, [dispatch, studentId])

    useEffect(() => {
        fetchStudent()
    }, [fetchStudent])

    return {
        studentId: studentId ?? null,
        refresh: fetchStudent,
    }
}
